import { Props_SnippetImageContentIcon } from './ImageContentIcon.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import VideoComponent from '../Shared/SharedVideo/SharedVideo'

const classAssignment = (prop: string | undefined | boolean, positiveClassName: string, negativeClassName = '') => {
    if (prop) {
        if (typeof prop === 'string') {
            return `${positiveClassName}--${prop}`
        }
        if (typeof prop === 'boolean') {
            return positiveClassName
        }
    }
    return negativeClassName
}

const SnippetImageContentIcon = (props: Props_SnippetImageContentIcon) => {
    const { snippet, heading, intro, image, video, icon, content, repeatable_link, link } = props

    const classHeadingVisibility = classAssignment(heading.visibility?.value, 'snippet-image-content-icon__heading--visible', 'snippet-image-content-icon__heading--hidden')
    const classSnippetLayout = classAssignment(snippet.layout?.value, 'snippet-image-content-icon')
    const backgroundColorClass = classAssignment(snippet.backgroundColor?.value, 'snippet-image-content-icon--bg')
    const fontColorClass = classAssignment(snippet.fontColor?.value, 'snippet-image-content-icon--font')

    const modifierClasses = `${classSnippetLayout} ${backgroundColorClass} ${fontColorClass}`
    const hasVideo = !!video.url?.value

    return (
        <section className={`snippet-image-content-icon ${modifierClasses}`}>
            <div className="snippet-image-content-icon__container">
                <div className="snippet-image-content-icon__intro">
                    <h2 className={`snippet-image-content-icon__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                    {intro.content?.value && (
                        <div className="snippet-image-content-icon__intro-content">{CompileMarkdown(intro.content.value)}</div>
                    )}
                </div>

                <div className="snippet-image-content-icon__body">
                    <div className="snippet-image-content-icon__container-image">
                        {hasVideo ? (
                            <VideoComponent
                                snippetClassName="snippet-image-content-icon"
                                url={video.url.value}
                                directEmbed={true}
                                audioDescriptionUrl={video.audioDescriptionUrl?.value || undefined}
                            />
                        ) : (
                            <img
                                loading="lazy"
                                src={image.src.value}
                                className="snippet-image-content-icon__image"
                                height="360"
                                width="600"
                                alt={image.alt?.value || ''}
                            />
                        )}
                    </div>
                    <div className="snippet-image-content-icon__container-content">
                        {content.content?.value && (
                            <div className="snippet-image-content-icon__content">
                                {CompileMarkdown(content.content.value)}
                            </div>
                        )}
                        {icon.src?.value && (
                            <div className="snippet-image-content-icon__icon-wrapper">
                                <img
                                    loading="lazy"
                                    src={icon.src.value}
                                    className="snippet-image-content-icon__icon"
                                    alt={icon.alt?.value || ''}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`snippet-image-content-icon__button-container snippet-image-content-icon__button-container--${link.alignment?.value || 'center'}`}>
                    {repeatable_link.map(({ linkHref, linkStyle, linkTarget, linkText, linkAriaLabel }, index) => (
                        <div key={index + (linkHref?.value || '')} className="snippet-image-content-icon__link">
                            <SnippetLink
                                linkStyles={linkStyle?.value}
                                className="snippet-image-content-icon__link"
                                url={linkHref?.value}
                                openInNewTab={linkTarget?.value}
                                aria-label={linkAriaLabel?.value || linkText?.value}
                            >
                                {linkText?.value}
                            </SnippetLink>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetImageContentIcon
